<template>
    <InnerImageZoom :src="src" class="parking-image" />
</template>

<script>
    import InnerImageZoom from 'vue-inner-image-zoom';
    import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';

    export default {
        props: ['src'],
        components: {
            InnerImageZoom
        }
    }
</script>
